const apipath = process.env.NODE_ENV == 'development' ? 'http://localhost:9999/api' : '/api'
const wspath = process.env.NODE_ENV == 'development' ? 'localhost:9999/api/ws' : '/api/ws'
// const request = mande(process.env.apihost || apipath)


// send
// const sends = async function(name, req){
//   req = req || {}
//   console.log('req', {name, req})
//   try {    
//     let resp = await request.post({name, req})
//     console.log('resp', {name, resp})    
//     return resp || {}

//   } catch (error) {
//     // console.error(error.body)
//     return {error:{id:'conn', code: 500}}    
//   }
// };

let send = async function(name, req){  
  if (!req) req = {}
  console.log('req', {name, req})
  req = JSON.stringify({name, req})  
  const request = new Request(apipath, {
    headers: {"Content-Type": "application/json"},
    method: "POST",
    body: req,
  });

  try {
    const response = await fetch(request)
    let result = await response.json() || {}
    console.log(result)
    return result || {}
  } catch (error) {
    console.error("Error:", error);
    console.log("Error:", error);
    return {error:{id:'try',code:500, error: error}}
  }
}

let file = async function(name, req, image){  
  if (!req) req = {}
  console.log('req', {name, req})
  req = JSON.stringify({name, req})  
  const request = new Request(apipath, {
    headers: {"Content-Type": "application/json"},
    method: "POST",
    body: req,
  });

  try {
    const response = await fetch(request)
    let result = await response.blob()
    if (image) {
      const objectURL = URL.createObjectURL(result);
      return objectURL;
    }

    return result
    
  } catch (error) {
    console.error("Error:", error);
    console.log("Error:", error);
    return {error:{id:'try',code:500, error: error}}
  }
}




// api
export default {

  async send(name,req) {return await send(name,req)},

  // support($route, $refs.supportMessage, console.logs)
  async support(route, message, logs) {return await send('support',{route, message, logs})},
  
  // team
  team:{ 
    async create(account) {return await send('admin/team/create',{account})},
    async list() {return await send('admin/team/list',{})},
    async update(id, k, v) {return await send('admin/team/update',{id,k,v})},
    async updates(list) {return await send('admin/team/updates',{list})}, //[]{id,k,v}
    async delete(id) {return await send('admin/team/delete',{id})},
  },

  // news
  assets:{ 
    async create(news, channels) {return await send('admin/asset/create',{news,channels})},
    async search(q) {return await send('admin/asset/search',{q})},
    async update(id, k, v) {return await send('admin/asset/update',{id, k,v})},
    async delete(id) {return await send('admin/asset/delete',{id})},
  },

  // news
  accounts:{ 
    async add(links) {return await send('admin/accounts/add',{links})},
    async update(id, k, v) {return await send('admin/accounts/update',{id, k,v})},
    async search(q) {return await send('admin/accounts/search',{q})},
    async delete(id) {return await send('admin/accounts/delete',{id})},
  },

  image:{
    async delete(id, link) {return await send('admin/assets/image/delete',{id, link})},
  },

  download:{
     async image(id) {return await file('admin/files/download',{id}, true)},
     async file(id) {return await file('admin/files/download',{id})},
  },

  upload:{
    async logo(id, image){return await send('admin/dict/upload/logo',{id, image})},
    // async image(id, image){return await send('upload/image',{id, image})},
    

    //file = image body or base64
    async image(file){
      return new Promise(function (resolve, reject) {
        const rs = new XMLHttpRequest();
        let host = `${apipath}/upload/image`;   
        console.log('upload/image',host)
        rs.open('post', host, true);
        rs.onload = function () {
          if (rs.status != 200)
            reject({ error: { id: 'try' } });
          if (!rs.response) resolve({});
          const resp = JSON.parse(rs.response);
          resolve(resp || {});
        };
        const uint8 = new Uint8Array(file);
        rs.send(uint8);
      });
    }, 

    async file(file, name, asset){
      return new Promise(function (resolve, reject) {
        const rs = new XMLHttpRequest();
        let host = `${apipath}/upload/file?name=${name}&asset=${asset}`;        
        rs.open('post', host, true);
        rs.onload = function () {
          if (rs.status != 200)
            reject({ error: { id: 'try' } });
          if (!rs.response) resolve({});
          const resp = JSON.parse(rs.response);
          resolve(resp);
        };
        const uint8 = new Uint8Array(file);
        rs.send(uint8);
      });
    }, 

    async doc(file){
      return new Promise(function (resolve, reject) {
        const rs = new XMLHttpRequest();
        let host = `${apipath}/upload/doc`;        
        rs.open('post', host, true);
        rs.onload = function () {
          if (rs.status != 200)
            reject({ error: { id: 'try' } });
          if (!rs.response) resolve({});
          const resp = JSON.parse(rs.response);
          resolve(resp);
        };
        const uint8 = new Uint8Array(file);
        rs.send(uint8);
      });
    }, 
    
   
    
    
  },

  
  
}




